__turbopack_context__.v({
  "error": "TextBox-module__kBizRG__error",
  "errorEBBHomePage": "TextBox-module__kBizRG__errorEBBHomePage",
  "eye-icon": "TextBox-module__kBizRG__eye-icon",
  "input-group": "TextBox-module__kBizRG__input-group",
  "msgBlock": "TextBox-module__kBizRG__msgBlock",
  "success": "TextBox-module__kBizRG__success",
  "textBox": "TextBox-module__kBizRG__textBox",
});
